/* ============================================================
   LIYAN — comportements du theme. Aucune dependance.
   Tout est enferme dans une IIFE : rien ne fuit dans le scope
   global (c'est exactement le bug qui cassait le snippet
   measure-header-heights d'Horizon).
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- 1. Aucun tiroir ouvert au chargement ----------
     Horizon restaure parfois l'etat "panier ouvert", ce qui applique
     margin-right: 480px sur toute la page et retrecit le site. */
  function closeDrawers() {
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.classList.remove('page-wrapper--drawer-open');
    each(document.querySelectorAll('dialog[open]'), function (d) {
      if (!d.closest('#MainContent')) { try { d.close(); } catch (e) {} }
    });
  }

  /* ---------- 2. Image d'attente des videos -----------------

     NOTE POUR PLUS TARD — la pixellisation du heros s'est reglee a
     l'envoi, pas ici. Shopify nomme ses rendus d'apres la HAUTEUR et
     n'agrandit jamais : une source verticale 1088x1920 plafonnait donc
     a 612 px de LARGE (son rendu "HD-1080p"), etire 2,4x sur un heros
     de 1470 px. Les memes sources recadrees en paysage a une hauteur
     de 720 px exactement donnent un rendu "HD-720p" de 1088 et 1440 px
     de large. Toute nouvelle video de banniere doit donc etre envoyee
     en paysage, hauteur 720 ou 1080, jamais en vertical.

     A NE PAS TENTER : servir le fichier d'origine
     (/videos/c/o/v/<hash>.mp4). Il arrive en "application/octet-stream"
     AVEC "X-Content-Type-Options: nosniff" : le navigateur refuse de le
     decoder, la video reste noire sans lever d'erreur. */
  var PREVIEW_BASE =
    'https://cdn.shopify.com/s/files/1/0778/2629/3917/files/preview_images/';

  function setPosters() {
    each(document.querySelectorAll('video'), function (v) {
      if (v.getAttribute('poster')) return;
      var src = v.currentSrc || v.src || '';
      if (!src) {
        var s0 = v.querySelector('source');
        src = s0 ? (s0.src || s0.getAttribute('src') || '') : '';
      }
      var i = src.indexOf('/c/vp/');
      if (i < 0) return;
      var rest = src.slice(i + 6);
      var cut = rest.indexOf('/');
      if (cut < 1) return;
      v.setAttribute('poster', PREVIEW_BASE + rest.slice(0, cut) + '.thumbnail.0000000000.jpg');
    });
  }

  /* ---------- 3. Lecture des videos de fond -----------------

     Sur mobile, l'attribut autoplay est ignore SANS ERREUR dans
     plusieurs situations que la page ne peut pas detecter a l'avance :
     mode economie d'energie iOS, economiseur de donnees, onglet
     restaure depuis l'arriere-plan. La video reste alors figee sur son
     poster et rien n'indique pourquoi.

     Le lecteur mobile du heros n'a qu'une seule source, le rendu
     HD-1080p a 7,2 Mbit/s (4,76 Mo) : Horizon ne genere aucun repli
     plus leger, donc une connexion lente ne demarre jamais non plus.

     On relance donc explicitement, puis on retente au premier geste de
     l'utilisateur : iOS leve sa restriction des qu'il y a eu une
     interaction, quelle qu'elle soit. */
  function kick(v) {
    if (!v.paused) return;
    v.muted = true;            // propriete, pas seulement attribut : iOS l'exige
    v.playsInline = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* refuse : le poster reste affiche */ });
  }

  function kickVisible() {
    each(document.querySelectorAll('video[autoplay]'), function (v) {
      if (v.getBoundingClientRect().width > 0) kick(v);
    });
  }

  function setupAutoplay() {
    kickVisible();

    /* Une video peut n'etre decodable qu'apres le chargement complet,
       et le passage bureau/mobile change laquelle est visible. */
    each(document.querySelectorAll('video[autoplay]'), function (v) {
      v.addEventListener('loadeddata', function () { kick(v); });
    });
    window.addEventListener('load', kickVisible);
    window.addEventListener('orientationchange', kickVisible);
    window.addEventListener('pageshow', kickVisible);

    /* Reprise au premier geste : couvre le mode economie d'energie,
       l'economiseur de donnees et les onglets restaures. */
    var done = false;
    function onGesture() {
      if (done) return;
      done = true;
      kickVisible();
    }
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, onGesture, { once: true, passive: true });
    });

    /* L'onglet revient au premier plan : iOS met en pause en arriere-plan. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kickVisible();
    });
  }

  /* ---------- 4. Apparition au defilement -------------------
     Une section qui contient des cartes n'est PAS animee elle-meme :
     on anime ses cartes. Sinon deux fondus se superposent, et c'est
     precisement ce qui rendait l'effet desagreable. */
  var observer = null;

  function setupReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        each(entries, function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-visible');
          observer.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    }

    var targets = [];
    var sections = document.querySelectorAll('#MainContent > .shopify-section');

    each(sections, function (s, i) {
      if (i === 0) return;                       // le premier bloc est deja a l'ecran
      var cards = s.querySelectorAll('.product-card');
      if (cards.length) {
        each(cards, function (c, j) {
          if (c.classList.contains('liyan-reveal')) return;
          c.classList.add('liyan-reveal', 'liyan-stagger');
          c.style.setProperty('--liyan-d', (j % 4) * 60 + 'ms');
          targets.push(c);
        });
      } else if (!s.classList.contains('liyan-reveal')) {
        s.classList.add('liyan-reveal');
        targets.push(s);
      }
    });

    each(targets, function (t) { observer.observe(t); });

    /* Filet de securite : si l'observateur ne se declenche jamais
       (conteneur de defilement inattendu, onglet en arriere-plan),
       le contenu ne doit pas rester invisible. */
    setTimeout(function () {
      each(targets, function (t) { t.classList.add('is-visible'); });
    }, 2500);
  }

  /* ---------- 5. En-tete et retour en haut ------------------
     Horizon ne fait pas toujours defiler documentElement : on ecoute
     en phase de capture et on lit la cible reelle de l'evenement. */
  function setupScroll() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'liyan-top';
    btn.setAttribute('aria-label', 'Revenir en haut de la page');
    btn.textContent = '↑';
    document.body.appendChild(btn);

    var scroller = null;

    btn.addEventListener('click', function () {
      var el = scroller || document.scrollingElement || document.documentElement;
      el.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      var node = (t === document || t === window || t === document.documentElement)
        ? (document.scrollingElement || document.documentElement)
        : t;
      if (!node || typeof node.scrollTop !== 'number') return;
      scroller = node;
      var y = node.scrollTop;
      document.documentElement.classList.toggle('liyan-scrolled', y > 8);
      btn.classList.toggle('is-visible', y > 700);
    }, true);
  }

  /* ---------- 6. Pastille panier ---------------------------- */
  function bumpCart() {
    var b = document.querySelector('[class*="cart-bubble"], [class*="cart-count"], .header__cart-count');
    if (!b) return;
    b.classList.remove('liyan-bump');
    void b.offsetWidth;                          // force le rejeu de l'animation
    b.classList.add('liyan-bump');
  }

  ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, bumpCart);
  });

  /* ---------- 7. Demarrage ---------------------------------- */
  function init() {
    closeDrawers();
    setPosters();
    setupAutoplay();
    setupReveal();
    setupScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Horizon recharge des sections en AJAX (filtres, variantes) */
  document.addEventListener('shopify:section:load', function () {
    setPosters();
    setupReveal();
    kickVisible();
  });
})();
